import { computed } from 'vue'
import type { PriceDisplayProps } from '@/components/atom/price-display/PriceDisplay.vue'

export const usePriceDisplayState = (props: PriceDisplayProps) => {
  const classes = computed(() => {
    return {
      'price-display': true,
      'price-display__is-loading': props.isLoading,
      'price-display__is-valid': props.isValid
    }
  })

  const showPrefix = computed(() => {
    return !!props.price && props.price > 0 && !props.isValid
  })

  const showPriceNumber = computed(() => {
    return !!props.price && props.price > 0
  })

  return {
    classes,
    showPrefix,
    showPriceNumber
  }
}
